import React, {ReactNode} from 'react';

import {invoiceCreationPage} from 'models/documents/invoices/create';

import {Helper} from '../Helper';

import {ClickableTab, Tab, TabList} from './styled';

type Props = {
    steps: Array<{
        label: ReactNode | string;
        component: ReactNode;
        helper?: ReactNode | string;
        passed?: boolean;
    }>;
    activeStep: number;
    isClickable?: boolean;
    clickCallback?: () => void;
    extraStyles?: string;
    errorTabs?: number[];
};

const SetTab = ({
    elem,
    index,
    activeStep,
    isClickable,
    errorTabs,
    clickCallback,
}: {
    elem: Props['steps'][number];
    index: number;
    activeStep: number;
    isClickable?: boolean;
    errorTabs?: number[];
    clickCallback?: (x?: any) => void;
}) => {
    function doClick(index: number) {
        if (clickCallback) {
            clickCallback(index);
            return;
        }

        invoiceCreationPage(index);
    }

    if (isClickable) {
        return (
            <ClickableTab
                type="button"
                onClick={() => {
                    if (isClickable) {
                        doClick(index);
                    }
                }}
                key={index}
                step={index + 1}
                passed={(elem.passed && index !== activeStep) ?? index < activeStep}
                active={index === activeStep}
            >
                {elem.label}
                {elem.helper && <Helper content={elem.helper} />}
            </ClickableTab>
        );
    }
    return (
        <Tab
            onClick={() => {
                if (isClickable) {
                    doClick(index);
                }
            }}
            key={index}
            step={index + 1}
            passed={index < activeStep}
            active={index === activeStep}
            hasError={errorTabs?.includes(index)}
        >
            {elem.label}
            {elem.helper && <Helper content={elem.helper} />}
        </Tab>
    );
};

export const Stepper = ({
    steps,
    activeStep,
    isClickable,
    clickCallback,
    extraStyles,
    errorTabs,
}: Props) => (
    <>
        <TabList extraStyles={extraStyles}>
            {steps.map((elem, index) => (
                <SetTab
                    elem={elem}
                    index={index}
                    isClickable={isClickable}
                    clickCallback={clickCallback}
                    activeStep={activeStep}
                    errorTabs={errorTabs}
                />
            ))}
        </TabList>
        {steps[activeStep].component}
    </>
);
